<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    &nbsp
                    <div>
                        <multiselect
                            v-model="search.sale_id"
                            :options="sellers"
                            track-by="id"
                            :multiple="true"
                            label="name"
                            :close-on-select="false"
                            :show-labels="false"
                            placeholder="เลือกเซลล์">
                        </multiselect>
                    </div>
                    &nbsp
                    <!--                    <label class="col-form-label">เลือกช่วงวัน</label>-->
                    <!--                    &nbsp &nbsp-->
                    <date-picker
                        v-model="search.start_date"
                        type="date"
                        format="DD/MM/YYYY"
                        lang="en"
                        :not-after="currentDate"
                        placeholder="วันที่เริ่มต้น">
                    </date-picker>
                    &nbsp
                    <date-picker
                        v-model="search.end_date"
                        type="date"
                        format="DD/MM/YYYY"
                        lang="en"
                        :not-before="search.start_date"
                        :not-after="currentDate"
                        placeholder="วันที่สิ้นสุด">
                    </date-picker>
                    &nbsp
                    <select class="form-control" v-model="search.product_type_id">
                        <option disabled selected :value="0">เลือกประเภทสินค้า</option>
                        <option
                            v-for="options in optionProductType"
                            :value="options.value">{{ options.name }}
                        </option>
                    </select>
                    &nbsp
                    <button @click="searchSale"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="mt-5 row form-group pl-5 pr-5">
            <label style="color: red">**หากไม่เลือกวันที่จะแสดงข้อมูลเฉพาะวันนี้</label>
            <div class="col-12 pl-0 pr-0 form-group" style="border: 3px solid  #ffc000;height: 450px">
                <div style="background-color: #ffc000;color: white;font-size: 18px">
                    <label class="pl-3">จำแนกยอดขายตามประเภทสินค้า</label>
                </div>
                <div class="pl-0 row col-9" style=" display: flex;
                                            align-items: center;
                                            justify-content: center;">
                    <template v-if="pieOverviewProduct.series.length > 0">
                        <apexchart type=pie
                                   width="550"
                                   ref="pieOverviewProduct"
                                   class="size-chart"
                                   id="pieOverviewSeller"
                                   :options="this.pieOverviewProduct.chartOptions"
                                   :series="pieOverviewProduct.series"/>
                    </template>
                    <template v-else>
                        <br/>
                        <label>ไม่พบข้อมูล</label>
                    </template>
                </div>
            </div>
            <div class="col-12 pl-0 pr-0 form-group" style="border: 3px solid  #ffc000">
                <div style="background-color: #ffc000;color: white;font-size: 18px">
                    <label class="pl-3">จำแนกยอดขายตามตัวแทนจำหน่าย</label>
                </div>
                <div class="pl-0 row col-9" style=" display: flex;
                                            align-items: center;
                                            justify-content: center;">
                    <template v-if="pieOverviewSeller.series.length > 0">
                        <apexchart type=pie
                                   width="600"
                                   ref="pieOverviewSeller"
                                   class="size-chart"
                                   :options="this.pieOverviewSeller.chartOptions"
                                   :series="pieOverviewSeller.series"/>
                    </template>
                    <template v-else>
                        <br/>
                        <label>ไม่พบข้อมูล</label>
                    </template>
                </div>
            </div>
        </div>

        <b-modal hide-footer hide-header ref="loading">
            <loading @submit="hideLoadingModal" :msg="msg" :status="status_loading"></loading>
        </b-modal>
        <br>
        <!--<pre class="alert alert-danger">{{OrderList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Loading from "../Utility/Loading";
import Multiselect from "vue-multiselect";

export default {
    name: "dashboard-selling",
    components: {
        Loading,
        DatePicker,
        Multiselect
    },
    created() {
        this.$store.dispatch("Dashboard/clearSearch");
        this.setPieChart();
        this.$store.dispatch("ProductType/get");
        this.$store.dispatch("Seller/get");
        // this.getOrderList();
    },
    computed: {
        ...mapState({
            sales: state => {
                return state.Dashboard.sale_by_seller;
            },
            sales_product: state => {
                return state.Dashboard.sale_by_product;
            },
            search: state => {
                return state.Dashboard.search;
            },
            optionProductType: state => {
                return state.ProductType.data;
            },
            sellers: state => {
                return state.Seller.data;
            },
        })
    },
    data() {
        return {
            msg: "",
            status_loading: 1,
            data: [],
            event_submit: false,
            currentDate: "",
            OrderList: [],
            pieOverviewSeller: {
                series: [],
                chartOptions: {
                    labels: [],
                    responsive: [{
                        breakpoint: 870,
                        options: {
                            chart: {
                                width: 400,
                            },
                            legend: {
                                position: 'bottom'
                            }

                        }
                    }],
                    theme: {
                        palette: 'palette5'
                    }
                },
            },
            pieOverviewProduct: {
                series: [],
                chartOptions: {
                    labels: [],
                    responsive: [{
                        breakpoint: 870,
                        options: {
                            chart: {
                                width: 400,
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }],
                    theme: {
                        palette: 'palette1'
                    }
                },
            },
            pieSetter: {
                series: [100],
                chartOptions: {
                    labels: ['ไม่มีข้อมูล'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200,
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }],
                },
            }

        };
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        // getOrderList(){
        //     this.$store.dispatch("Order/setOrders").then(res=>{
        //         if(res.data.length > 5){
        //             this.OrderList = res.data.slice(0,5);
        //         }else{
        //             this.OrderList = res.data;
        //         }
        //         this.setPieChart();
        //         this.getCurrentDate();
        //     });
        // },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
        },
        dataPointSelectionHandler(e, chartContext, config) {
            // //console.log('1',config.w.config.labels[config.dataPointIndex]);
        },
        searchSale() {
            this.event_submit = true;
            this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
            this.status_loading = 1;
            this.showLoadingModal();
            if (this.search.start_date && this.search.end_date) {
                this.search.start_date = moment(this.search.start_date).format("YYYY-MM-DD");
                this.search.end_date = moment(this.search.end_date).format("YYYY-MM-DD");
            }
            if (this.search.sale_id.length > 0) {
                let id = '';
                this.search.sale_id.forEach((v, i) => {
                    i == this.search.sale_id.length - 1 ? id += v.id : id += v.id + ','
                })
                this.search.sale_id = id;
            }
            this.$store.dispatch("Dashboard/search", this.search).then(() => {
                this.pieOverviewSeller.series = []
                this.pieOverviewSeller.chartOptions.labels = []
                this.sales.forEach((seller, i) => {
                    if (seller.total > 0) {
                        this.pieOverviewSeller.series.push(seller.total);
                    } else {
                        this.pieOverviewSeller.series.push(0);
                    }

                })
                this.$refs.pieOverviewSeller.updateSeries([{
                    data: this.pieOverviewSeller.series
                }])

                let self = this;
                this.pieOverviewProduct.series = [];
                $.each(this.sales_product, function (key, value) {
                    self.pieOverviewProduct.series.push(value.total);
                });
                this.$refs.pieOverviewProduct.updateSeries([{
                    data: this.pieOverviewProduct.series
                }])
                this.hideLoadingModal();
            }).catch(() => {
                this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                this.status_loading = 3;
                this.showLoadingModal();
            })
        },
        setPieChart() {
            this.$store.dispatch("Dashboard/getSaleGroupBySeller").then(() => {
                let sale_name;
                let total;
                this.sales.forEach(seller => {
                    if (seller.sale) {
                        sale_name = seller.sale.name
                        this.pieOverviewSeller.chartOptions.labels.push(sale_name);
                    }
                    if (seller.total) {
                        total = seller.total
                        this.pieOverviewSeller.series.push(total);
                    }
                })
            });
            this.$store.dispatch("Dashboard/getSaleGroupByProduct").then(() => {
                let self = this;
                $.each(this.sales_product, function (key, value) {
                    self.pieOverviewProduct.chartOptions.labels.push(value.product_name);
                    self.pieOverviewProduct.series.push(value.total);
                });
            });
        }
    }
}

</script>


<style scoped>
.size-chart {
    max-height: 290px !important;
    max-width: 380px !important;
}

@media only screen and (max-width: 761px) {
    .size-chart {
        max-height: 150px;
        max-width: 380px;
    }
}


</style>
